"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function AudioIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M20.376,2.978a.85.85,0,0,0-1.13-.8L7.378,6.322a.852.852,0,0,0-.57.8v8.939a3.03,3.03,0,0,0-1.38-.343A3.076,3.076,0,1,0,8.5,18.805h.007V12.1l.074.213L18.676,8.78V13.7a3.046,3.046,0,0,0-1.381-.341,3.075,3.075,0,1,0,3.07,3.144h.011ZM5.428,20.172A1.376,1.376,0,1,1,6.8,18.8,1.377,1.377,0,0,1,5.428,20.172Zm3.081-9.639v-2.8L18.676,4.175v2.8ZM17.3,17.812a1.376,1.376,0,1,1,1.376-1.376A1.377,1.377,0,0,1,17.3,17.812Z" })));
}
exports.default = AudioIcon;
